import './SponsorsPage.css'

import React from 'react'
import Markdown from 'react-markdown'
import { withProps } from 'recompose'

import { getSponsorsContent } from '../app/selectors'
import content from '../content'

const SponsorsPage = ({ sections }) => (
  <div>
    {sections.map((section, i) => (
      <div key={i}>
        <Markdown source={section.text} />
        <div className="SponsorsPage-sponsors">
          {section.sponsors.map(sponsor => (
            <div key={sponsor.name} className="SponsorsPage-sponsorCard">
              {sponsor.link && (
                <a href={sponsor.link} target="_blank">
                  <img src={sponsor.logo} alt={sponsor.name} />
                </a>
              )}
              {!sponsor.link && <img src={sponsor.logo} alt={sponsor.name} />}
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
)

const sponsorsContent = getSponsorsContent(content)

const withPageContent = withProps({
  sections: sponsorsContent.sections,
})

export default withPageContent(SponsorsPage)



// WEBPACK FOOTER //
// ./src/containers/SponsorsPage.js